/* Stylesheet */

.custom_cohorts_wrapper {
  padding: 0;
  height: calc(100% - 60px);
  width: 100%;

  .row {
    height: 100%;

    .col {
      padding: 0px;
      height: 100%;
    }

    .cohort_builder_col {
      .wrapper_container {
        padding: 21px;
      }
    }

    .cohort_list_col {
      height: 100%;

      .wrapper_container {
        height: 100%;
        overflow: hidden;
        background: var(--ion-gradient-light);
        border-radius: 20% 0% 0% 10% / 100% 0% 0% 100%;
      }
    }
  }
}
